sofistik-friendly-captcha {
  display: block;
  min-height: 52px;
}
